var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUaeFintoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 717 220",
    width: 135,
    height: 47,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new fintoo logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #1f3060 } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: #c7beb8 } \n\t\t.s3 { fill: #d0cac7 } \n\t\t.s4 { fill: #f5f5f5 } \n\t\t.s5 { fill: #f68638 } \n\t\t.s6 { fill: #43271e } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m49.5 129.2h28.7c7.1 0 12.9-5.8 12.9-12.9v-11.7h-28.7c-7.1 0-12.9 5.8-12.9 12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m45.3 46.9c-15.6 0-28.2 12.6-28.2 28.2v106.3h1.4c15.2 0 27.6-11.7 28.8-26.6v-51.5c0-0.2 0-0.3 0.1-0.5v-15.7c0-8.6 7-15.6 15.6-15.6h7.6c13.4 0 24.2-10.8 24.2-24.2v-0.5h-49.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m124.1 181.4h-4.2v-107.5c0-14.9 12.1-27.1 27.1-27.1h3.2v108.4c0 14.4-11.7 26.1-26.1 26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m271.6 181.4h-3l-55.4-84.5c-3.3-4.9-5.5-8.7-6.8-11.2h-0.4c0.5 4.8 0.8 12 0.8 21.8v49.6c0 13.4-10.9 24.3-24.3 24.3h-4.3v-103.3c0-17.2 14-31.2 31.2-31.2h1.4l53.4 81.9c2.4 3.7 4.7 7.3 6.8 11h0.4c-0.5-3.1-0.8-9.3-0.8-18.5v-49.8c0-13.6 11-24.6 24.6-24.6h4v106.9c0 15.3-12.4 27.6-27.6 27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m399.5 71.6h-17.6v82.2c0 15.3-12.4 27.7-27.7 27.7h-2.7v-109.9h-38.2v-4c0-11.4 9.3-20.7 20.7-20.7h86.2v4c0 11.4-9.3 20.7-20.7 20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m638.4 183.8c-19.3 0-35-6.3-47.1-18.8-12.1-12.5-18.2-28.9-18.2-49 0-20.1 6.2-38.5 18.5-51.6 12.3-13.1 28.6-19.7 49-19.7 20.4 0 34.7 6.3 46.6 18.9 11.9 12.6 17.8 29.1 17.8 49.7 0 20.6-6.1 38.2-18.4 51.1-12.3 12.9-28.3 19.4-48.1 19.4zm1.3-113.1c-10.6 0-19.1 4-25.3 12-6.3 8-9.4 18.5-9.4 31.7 0 13.2 3.1 23.9 9.4 31.6 6.3 7.8 14.4 11.6 24.6 11.6 10.2 0 18.7-3.8 24.9-11.3 6.1-7.5 9.2-18 9.2-31.4 0-13.4-3-24.8-8.9-32.6-5.9-7.8-14.1-11.6-24.4-11.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m492.6 44.2c0 0 0 0.2 0 0.3 0 0 0 0.2 0 0.3-0.5 1-2.5 5.1-2.6 5.5-0.4 2.3 0.4 16.3 0.1 20.6 0.1 0.3 3.3 0.5 4.8 0.9 14.4 3.4 19.6 19.9 19.4 33.2l9.5 8.9 31.4-0.5c1.1-35.7-21.1-67.1-58.4-69 0-0.1 58.7-0.1 58.7-0.1v69.8h-65.9v-69.8h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m493.5 44.2c-0.3 0.2-0.6 0.1-1 0.3 0 0 0-0.2 0-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m494.6 44.2c-0.4 0.1-0.7 0.1-1.1 0.1 0-0.1 1.1-0.1 1.1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m496.9 44.2c-0.8 0-1.6 0.1-2.3 0.1 0-0.1 2.3-0.1 2.3-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m493.5 44.4c0.4 0 0.7 0 1.1 0 0.8 0 1.6 0 2.3 0 37.3 1.8 59.5 33.3 58.4 69l-31.4 0.5c-0.1-20-7.8-41.8-30.7-43.2l-0.2-0.2c-0.2-7.4 0-14.8-0.3-22.2 0-1.2 0-2.3-0.1-3.5 0 0 0-0.2 0-0.3 0.3-0.1 0.6-0.1 1-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m523.9 113.8l-9.5-8.9c0.2-13.2-4.9-29.8-19.4-33.2-1.5-0.4-4.7-0.6-4.8-0.9 0.2-4.2-0.5-18.2-0.1-20.6 0-0.4 2.1-4.5 2.6-5.5 0.2 1.2 0.1 2.3 0.1 3.5 0.2 7.4 0 14.8 0.3 22.2l0.2 0.2c22.9 1.4 30.6 23.1 30.7 43.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m522 119c-0.6 11.3-3.6 20.3-9.1 27-6.1 7.5-14.4 11.3-24.9 11.3-10.5 0-18.3-3.9-24.6-11.6-6.3-7.8-9.4-18.3-9.4-31.6 0-13.3 3.1-23.7 9.4-31.7 5.7-7.3 13.3-11.2 22.7-11.9v-26.1c-18.7 0.7-33.9 7.3-45.5 19.6-12.3 13.1-18.5 30.3-18.5 51.6 0 21.3 6.1 36.5 18.2 49 12.1 12.5 27.8 18.8 47.1 18.8 19.3 0 35.8-6.5 48.1-19.4 11.1-11.7 17.1-26.7 18.2-45h-31.8z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaeFintoo);
export default __webpack_public_path__ + "static/media/UAEFintoo.8a781ce9e93b7e42412c8c4763ef9f8a.svg";
export { ForwardRef as ReactComponent };